var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.32 10.8699C20.32 5.64995 16.09 1.41999 10.87 1.41999C5.65 1.42999 1.42 5.64995 1.42 10.8699C1.42 16.0899 5.65 20.3198 10.87 20.3198C16.09 20.3198 20.32 16.0899 20.32 10.8699ZM0 10.8699C0 4.86995 4.87 0 10.87 0C16.87 0 21.74 4.86995 21.74 10.8699C21.74 16.8698 16.87 21.7398 10.87 21.7398C4.85999 21.7398 0 16.8698 0 10.8699Z",
    fill: "#D87832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 14.0598C10.55 14.0598 10.24 14.1798 9.98998 14.4198C9.73998 14.6598 9.60999 14.9698 9.60999 15.3398C9.60999 15.7198 9.73998 16.0198 9.98998 16.2598C10.24 16.4998 10.54 16.6098 10.9 16.6098C11.26 16.6098 11.57 16.4898 11.82 16.2598C12.07 16.0198 12.19 15.7198 12.19 15.3398C12.19 14.9698 12.07 14.6598 11.82 14.4198C11.56 14.1798 11.26 14.0598 10.9 14.0598Z",
    fill: "#D87832"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.71 5.11987H10.89H10.81H10.09C9.82998 5.11987 9.61998 5.32987 9.61998 5.58987C9.61998 6.64987 10.01 11.9299 10.09 12.5399C10.12 12.7599 10.31 12.9299 10.54 12.9299H10.82H10.9H11.27C11.5 12.9299 11.69 12.7599 11.72 12.5399C11.8 11.9199 12.19 6.64987 12.19 5.58987C12.18 5.32987 11.97 5.11987 11.71 5.11987Z",
    fill: "#D87832"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d886743a.svg";
export { ForwardRef as ReactComponent };